import React from 'react';
import PropTypes from 'prop-types';
import './LifecycleEventChips.scss';

// Admin-only debug chips listing the client events a row published — quiet, mono. The
// visibility decision (admin control mode) and the replay side effect (re-emitting onto the
// app's lifecycle-event bus) are app concerns, inverted to props: `visible` gates rendering
// and `onReplay(entry)` receives the clicked { event, params, row } entry — the caller tags
// each entry with its source row and rebuilds the envelope itself.
const LifecycleEventChips = ({ events, visible = false, onReplay }) => {
  if (!visible || !Array.isArray(events) || !events.length) return null;
  return (
    <div className='ap-lifecycle-events'>
      <span className='ap-lifecycle-events-glyph' aria-hidden='true'>↻</span>
      {events.map((e, i) => (
        <button
          key={i}
          type='button'
          className='ap-lifecycle-events-name'
          title='Re-run this event locally'
          onClick={() => onReplay && onReplay(e)}
        >
          {(e && e.event) || 'unknown'}
        </button>
      ))}
    </div>
  );
};

LifecycleEventChips.propTypes = {
  events: PropTypes.array,
  visible: PropTypes.bool,
  onReplay: PropTypes.func
};

export default LifecycleEventChips;
